// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"215":"cdb69cca","241":"5014ecae","818":"7d0387bc","827":"435fd61b"}[chunkId] + ".css";
};